
export function toCommas(value, decimals) {
    const cleaned = typeof value === 'string' ? value.replace(/,/g, '') : value;
    const numeric = Number(cleaned);
    if (Number.isNaN(numeric)) return '0';
    const formatted = typeof decimals === 'number'
        ? numeric.toFixed(decimals)
        : numeric.toString();
    const [integer, fraction] = formatted.split('.');
    const withCommas = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fraction ? `${withCommas}.${fraction}` : withCommas;
}
